import angular from 'angular';

import LayoutService from './layout.service';

const ServicesModule = angular
    .module('control-room.commons.layout.services', [])
    .service('layoutService', LayoutService);

export default ServicesModule;
